import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "col-lg-8 col-md-10 mt-4" }
const _hoisted_4 = { class: "col mb-3" }
const _hoisted_5 = { class: "col mb-3" }
const _hoisted_6 = {
  key: 0,
  class: "text-danger mt-2"
}
const _hoisted_7 = {
  key: 0,
  class: "col mb-3"
}
const _hoisted_8 = {
  key: 0,
  class: "text-muted d-block"
}
const _hoisted_9 = {
  key: 1,
  class: "text-muted d-block"
}
const _hoisted_10 = {
  key: 2,
  class: "text-warning d-block"
}
const _hoisted_11 = {
  key: 3,
  class: "text-danger"
}
const _hoisted_12 = { class: "col-md-12 mb-3" }
const _hoisted_13 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_14 = { class: "col-md-12" }
const _hoisted_15 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_16 = { class: "mb-3 mt-1" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        class: "row g-3",
        "validation-schema": _ctx.schema,
        onSubmit: _ctx.sendOuvFer
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[4] || (_cache[4] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                _createTextVNode(" Date d'ouverture "),
                _createElementVNode("span", { class: "text-danger" }, "*")
              ], -1)),
              _createVNode(_component_Field, {
                name: "dateOuverture",
                class: "form-control shadow-none fs-md-15 text-black",
                type: "datetime-local",
                max: _ctx.currentDateTime,
                modelValue: _ctx.dateOuverture,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dateOuverture) = $event)),
                readonly: ""
              }, null, 8, ["max", "modelValue"]),
              _createVNode(_component_ErrorMessage, {
                name: "dateOuverture",
                class: "text-danger"
              })
            ]),
            _createElementVNode("div", _hoisted_5, [
              _cache[5] || (_cache[5] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                _createTextVNode("Caisse "),
                _createElementVNode("span", { class: "text-danger" }, "*")
              ], -1)),
              _createVNode(_component_Field, { name: "caisse" }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_Multiselect, _mergeProps({
                    modelValue: _ctx.caisse,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.caisse) = $event)),
                    options: _ctx.caisseOptions,
                    "preserve-search": true,
                    multiple: false,
                    searchable: true,
                    placeholder: "Sélectionner la caisse",
                    label: "label",
                    "track-by": "value"
                  }, field, { onChange: _ctx.handleCaisseChange }), null, 16, ["modelValue", "options", "onChange"])
                ]),
                _: 1
              }),
              _createVNode(_component_ErrorMessage, {
                name: "caisse",
                class: "text-danger"
              }),
              (_ctx.caisseOptions.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Aucune caisse disponible : aucune caisse affectée à cet utilisateur, ou toutes sont déjà ouvertes. "))
                : _createCommentVNode("", true)
            ]),
            (_ctx.caisse)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _cache[8] || (_cache[8] = _createElementVNode("label", {
                    for: "soldeOuverture",
                    class: "d-block text-black fw-semibold mb-10"
                  }, " Solde d'ouverture (Fcfa) ", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    min: "0",
                    id: "soldeOuverture",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.soldeOuverture) = $event)),
                    placeholder: "Entrer le solde d'ouverture"
                  }, null, 512), [
                    [
                      _vModelText,
                      _ctx.soldeOuverture,
                      void 0,
                      { number: true }
                    ]
                  ]),
                  (_ctx.soldeDerniereFermeture !== null)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_8, [
                        _cache[6] || (_cache[6] = _createTextVNode(" Solde de la dernière fermeture : ")),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.soldeDerniereFermeture.toLocaleString('fr-FR')) + " Fcfa", 1),
                        _cache[7] || (_cache[7] = _createTextVNode(". Vous pouvez saisir un autre montant. "))
                      ]))
                    : (_openBlock(), _createElementBlock("small", _hoisted_9, " Première ouverture de cette caisse : saisissez l'argent présent dans le tiroir. ")),
                  (_ctx.soldeModifie)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_10, " Ce solde est différent de celui de la dernière fermeture. "))
                    : _createCommentVNode("", true),
                  (_ctx.soldeInvalide)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, "Le solde d'ouverture doit être un nombre positif ou nul."))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _cache[9] || (_cache[9] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Personnes présentes à l'ouverture "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, { name: "user" }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      modelValue: _ctx.user,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.user) = $event)),
                      options: _ctx.userOptions,
                      searchable: true,
                      "track-by": "value",
                      mode: "tags",
                      label: "label",
                      placeholder: "Sélectionner la personne"
                    }, field), null, 16, ["modelValue", "options"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "user",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _cache[10] || (_cache[10] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Observation", -1)),
                _createVNode(_component_Field, {
                  name: "observations",
                  as: "textarea",
                  cols: "30",
                  rows: "8",
                  placeholder: "Entrer votre observation",
                  class: "form-control shadow-none rounded-0 text-black"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "observations",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("button", {
                type: "submit",
                class: "btn btn-primary top-end",
                disabled: _ctx.caisseOptions.length === 0 || _ctx.isSubmitting || _ctx.soldeInvalide
              }, [
                (_ctx.isSubmitting)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_18))
                  : _createCommentVNode("", true),
                _cache[11] || (_cache[11] = _createTextVNode(" Ouvrir "))
              ], 8, _hoisted_17),
              _createVNode(_component_router_link, {
                to: "/OuverturesFermetures/",
                type: "button",
                class: "btn btn-danger mx-1"
              }, {
                default: _withCtx(() => _cache[12] || (_cache[12] = [
                  _createTextVNode("Annuler")
                ])),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["validation-schema", "onSubmit"])
    ])
  ]))
}